import { EMPTY_EDR_EVENT_FILTERS, edrEventFilterCount, type EdrEventFacets, type EdrEventFilterValues } from '../api/securitee'

const WRAP = { display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 } as const
const CTRL = { width: 'auto', display: 'inline-block' } as const

/**
 * Bara de filtre de pe Securitee > EDR events: canal si ID de eveniment (din
 * facetele server), server-side. Perioada sta in antet, cautarea libera la
 * casuta DataTables. Cate una singura, ca dropdownurile din fila XDR.
 */
export function EdrEventsFilters({
  filters,
  facets,
  onChange,
}: {
  filters: EdrEventFilterValues
  facets: EdrEventFacets
  onChange(next: EdrEventFilterValues): void
}) {
  const active = edrEventFilterCount(filters)

  return (
    <div className="edr-filters" style={WRAP} role="group" aria-label="Filter EDR events">
      <select
        className="form-control input-sm edr-filter-channel"
        aria-label="Channel"
        style={CTRL}
        value={filters.channels[0] ?? ''}
        onChange={(e) => onChange({ ...filters, channels: e.target.value === '' ? [] : [e.target.value] })}
      >
        <option value="">All channels</option>
        {facets.channels.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <select
        className="form-control input-sm edr-filter-eventid"
        aria-label="Event ID"
        style={CTRL}
        value={filters.eventIds[0] ?? ''}
        onChange={(e) => onChange({ ...filters, eventIds: e.target.value === '' ? [] : [e.target.value] })}
      >
        <option value="">All event IDs</option>
        {facets.eventIds.map((id) => (
          <option key={id} value={String(id)}>
            {id}
          </option>
        ))}
      </select>

      {active > 0 && (
        <button type="button" className="btn btn-xs btn-link edr-filter-clear" onClick={() => onChange(EMPTY_EDR_EVENT_FILTERS)}>
          Clear filters ({active})
        </button>
      )}
    </div>
  )
}
